<template>
  <div class="container custom-mt">
    
    <div class="card mx-auto border-0 shadow-lg" style="max-width: 500px">
      <div class="card-header bg-transparent border-0 ms-2">
        <div>
          <img
            src="../../../assets/logo.png"
            alt="Logomarca"
            class="img-fluid mx-auto d-block mt-4"
            width="120"
          />
        </div>
      </div>

      <div class="card-body">
        <h4 class="text-center mb-4"><b>Entrada</b></h4>

        <div class="text-white error-label text-center" v-if="timeError" role="alert">
          <p class="">{{ errorLabel.messageError }}</p>
        </div>
        
        <div class="mb-4 ps-2 pe-2">
          <label for="nome" class="form-label">Cliente</label>

          <div>
            <div class="search-container">
              <span
                class="search-icon"
                v-if="!processPayload.client && !searchTerm"
              >
                <font-awesome-icon icon="magnifying-glass" />
              </span>
              <input
                v-model="searchTerm"
                @input="filterClients"
                :placeholder="getClientName(processPayload.client)"
                class="form-control"
              />
              <span
                class="clear-icon"
                @click="clearSearch"
                v-if="processPayload.client"
              >
                <font-awesome-icon icon="circle-xmark" />
              </span>
            </div>
            <select
              class="form-control"
              v-model="processPayload.client"
              size="3"
              v-if="searchTerm"
            >
              <option
                v-for="client in filteredClients"
                :key="client.id"
                :value="client.id"
              >
                {{ `${client.name}` }}
              </option>
            </select>
          </div>

          <p class="p-error-label">{{ errorLabel.client }}</p>
        </div>

        <div class="mb-3 ps-2 pe-2">
          <InputSelect  v-if="materials" :objetcSelect="materials" :setTitle="'Material'" @objectId="materialValue"/>
          <p class="p-error-label">{{ errorLabel.material }}</p>
        </div>

        <div class="mb-2 ps-2 pe-2 container-fluid">
          <label for="largura" class="form-label">Medidas do Material:</label>
          <div class="d-flex">

            <div class="row col me-1">
              <div class="col-12">
                <input
                  v-model="processPayload.width"
                  type="number"
                  class="form-control mb-2"
                  id="largura"
                  placeholder="Largura (metros)"
                  style=""
                />
                <p class="p-error-label">{{ errorLabel.width }}</p>
              </div>
            </div>

            <div class="row col">
              <div class="col-12">
                <input
                  v-model="processPayload.height"
                  type="number"
                  class="form-control"
                  id="altura"
                  placeholder="Altura (metros)"
                  style=""
                />
                <p class="p-error-label">{{ errorLabel.height }}</p>
              </div>
            </div>
          
          </div>
        </div>

        <div class="mb-4 ps-2 pe-2">
          <label for="quantidade" class="form-label">Quantidade:</label>
          <input
            v-model="processPayload.amount"
            type="number"
            class="form-control"
            id="quantidade"
            placeholder="Quantidade"
            style="width: 200px;"
          />
          <p class="p-error-label">{{ errorLabel.amount }}</p>
        </div>

        <div
          :class="`mb-4 ps-2 pe-2 ${
            processPayload.image ? 'd-flex align-items-center' : ''
          }`"
        >
          <div class="">
            <label for="formFileMultiple" class="form-label">Imagem</label>
            <input
              ref="fileInput"
              class="form-control"
              type="file"
              accept=".jpg,.jpeg,.pdf,.eps,image/jpeg,application/pdf,application/postscript"
              id="formFileMultiple"
              :disabled="sendProcess"
              @change="handleFileChange"
            />
            <small class="text-muted d-block mt-1">
              Formatos aceitos: JPEG, PDF ou EPS
            </small>
            <p class="p-error-label">{{ errorLabel.image }}</p>
          </div>

          <div
  v-if="processPayload.image"
  class="ms-4 mt-auto d-flex align-items-center justify-content-end flex-wrap"
>
  <img
    v-if="processPayload.fileType === 'image/jpeg'"
    :src="processPayload.image"
    alt=""
    height="60"
    width="60"
  />

  <iframe
    v-else-if="processPayload.fileType === 'application/pdf'"
    :src="processPayload.image"
    width="60"
    height="60"
    style="background:white"
  ></iframe>

  <div v-else-if="isEpsFile" class="text-center">
    <div v-if="epsPreviewLoading" class="d-flex flex-column align-items-center">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="mb-0 file-name-preview">Gerando prévia...</span>
    </div>

    <img
      v-else-if="epsPreview"
      :src="epsPreview"
      alt=""
      height="60"
      width="60"
    />

    <div v-else>
      <font-awesome-icon icon="file" size="2x" class="text-secondary" />
      <p class="mb-0 file-name-preview">{{ processPayload.fileName }}</p>
      <span class="badge bg-secondary" style="font-size: 9px;">EPS</span>
    </div>
  </div>
</div>
        </div>

        <div class="ps-2 pe-2">
          <label for="urgencia" class="form-label fw-bold">Prioridade</label>
        </div>

        <div class="mb-4 ps-2 pe-2 d-flex align-items-center">
          <div class="form-check me-4">
            <input
              v-model="processPayload.status"
              class="form-check-input"
              type="radio"
              name="nomal"
              id="normal"
              value="N"
              checked
            />
            <label class="form-check-label" for="normal"> Normal </label>
          </div>

          <div class="form-check">
            <input
              v-model="processPayload.status"
              class="form-check-input"
              type="radio"
              name="urgencia"
              id="urgente"
              value="U"
            />
            <label class="form-check-label" for="urgente"> Urgente </label>
          </div>
        </div>

        <div class="form-group my-3">
          <label for="comment">Comentário (opcional)</label>
          <textarea
            v-model="processPayload.comment"
            class="form-control"
            id="comment"
            rows="3"
          >
          </textarea>
        </div>

        <div class="d-grid gap-2">
          <button class="btn btn-dark ms-2 me-2" @click="registerProcess" v-if="!sendProcess">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-person-check"
              viewBox="0 0 16 16"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-person-check"
                viewBox="0 0 16 16"
              >
                <path
                  d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
                />
                <path
                  d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"
                />
              </svg>
            </svg>
            Registrar
          </button>
          <button class="btn btn-dark ms-2 me-2" type="button" disabled v-if="sendProcess">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Enviando...
          </button>
          <p v-if="sendProcess" class="text-center text-muted small mb-0">
            Não feche nem recarregue a página. Arquivos grandes podem demorar.
          </p>
          <button
            class="btn btn-outline-danger mb-4 ms-2 me-2"
            :disabled="sendProcess"
            @click="backHome"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-bar-left"
              viewBox="0 0 16 16"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-bar-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                />
              </svg>
            </svg>
            Voltar
          </button>
        </div>
      </div>
    </div>
  

  </div>
  <!-- Modal -->
</template>

<script>
import { computed, onBeforeMount, onBeforeUnmount, ref } from "vue";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import store from "../../../store";
import { createProcessDesign, midiaConvertEps } from "../../../http";
import { sendEventProcess, sendEventNotification } from "../../../socket";
import { getReponseMaterial, getReponseClients } from "../../../socket"
import InputSelect from "@/components/InputSelect.vue";

// Tempo máximo esperando a resposta do servidor antes de liberar o botão.
// (uploads grandes de EPS/PDF podem demorar, por isso é generoso)
const SEND_TIMEOUT_MS = 5 * 60 * 1000;

const withTimeout = (promise, ms) => {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error("TIMEOUT")), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};

export default {
  name: "CreateProcesses",
  props: {},
  setup() {
    const router = useRouter();
    const clients = computed(() => store.state.clientsList);
    const materials = computed(() => store.state.materialList);
    const user = computed(() => store.state.userCurrent);
    const timeError = ref(false);
    const sendProcess = ref(false);

    const processPayload = ref({
      client: null,
      status: "N",
      comment: null,
      image: null,
      fileName: null,
      fileType: null,
      material: null,
      amount: null,
      height: null,
      width: null,
      member: user.value.id,
    });

    const errorLabel = ref({
      client: null,
      messageError: null,
      image: null,
      material: null,
      amount: null,
      height: null,
      width: null,
    });

    const isEpsFile = computed(() => {
      return processPayload.value.fileType === "application/postscript" || processPayload.value.fileType === "image/eps";
    });

    const epsPreview = ref(null);
    const epsPreviewLoading = ref(false);

    // ---------- mensagens de erro do envio ----------
    let errorTimer = null;

    const showError = (message, duration = 8000) => {
      errorLabel.value.messageError = message;
      timeError.value = true;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(() => {
        timeError.value = false;
      }, duration);
      // o aviso fica no topo do card; no celular o botão está embaixo
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const getErrorMessage = (err) => {
      if (err?.message === "TIMEOUT") {
        return "O servidor demorou para responder. Confira na lista de processos se o pedido foi criado antes de tentar novamente.";
      }

      const noResponse =
        (err?.request && !err?.response) ||
        err?.code === "ERR_NETWORK" ||
        err instanceof TypeError;
      if (noResponse) {
        return "Falha de conexão ao enviar. Verifique a internet e tente novamente.";
      }

      let msg = err?.response?.data?.message ?? err?.message;
      if (Array.isArray(msg)) msg = msg.join(" ");
      return msg || "Não foi possível registrar o processo. Tente novamente.";
    };

    // ---------- evita perder o upload ao sair da tela ----------
    const warnBeforeUnload = (event) => {
      if (sendProcess.value) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", warnBeforeUnload);

    onBeforeRouteLeave(() => {
      if (sendProcess.value) {
        return window.confirm(
          "O envio ainda está em andamento. Se sair agora, o arquivo não será enviado. Deseja sair mesmo assim?"
        );
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", warnBeforeUnload);
      clearTimeout(errorTimer);
    });

    const validateForm = () => {

      errorLabel.value.client = null;
      errorLabel.value.description = null;
      errorLabel.value.messageError = null;
      errorLabel.value.image = null;
      errorLabel.value.material = null;
      errorLabel.value.amount = null;
      errorLabel.value.height = null;
      errorLabel.value.width = null;

      if(!processPayload.value?.image){
        errorLabel.value.image = "Campo obrigatório.";
      }

      if(!processPayload.value?.material){
        errorLabel.value.material = "Campo obrigatório.";
      }

      if(!processPayload.value?.amount){
        errorLabel.value.amount = "Campo obrigatório.";
      }

      if(!processPayload.value?.height){
        errorLabel.value.height = "Campo obrigatório.";
      }

      if(!processPayload.value?.width){
        errorLabel.value.width = "Campo obrigatório.";
      }

      if (!processPayload.value?.client) {
        errorLabel.value.client = "Campo obrigatório.";
      }

      if (errorLabel.value.client || 
          errorLabel.value.material ||
          errorLabel.value.amount ||
          errorLabel.value.height ||
          errorLabel.value.image ||
          errorLabel.value.width
        ) {
        return true;
      }
      return false;
    };

    const registerProcess = async () => {
      if (sendProcess.value) return; // evita duplo clique
      if (validateForm()) return;

      sendProcess.value = true;
      timeError.value = false;

      try {
        const responseProcess = await withTimeout(
          createProcessDesign(processPayload.value),
          SEND_TIMEOUT_MS
        );

        // Sucesso = veio o processo criado (com id). Qualquer outra coisa
        // ({ message }, undefined, resposta vazia) é tratada como erro.
        if (!responseProcess?.id) {
          showError(getErrorMessage({ response: { data: responseProcess } }));
          return;
        }

        responseProcess.material = processPayload.value.material;
        responseProcess.amount = processPayload.value.amount;
        responseProcess.height = processPayload.value.height;
        responseProcess.width = processPayload.value.width;
        responseProcess.materials = materials.value?.find(mt => mt.id === responseProcess.material);

        // Uma falha no socket não pode virar "erro ao registrar":
        // o processo já foi criado e reenviar duplicaria o pedido.
        try {
          sendEventNotification("graphic", true);
          sendEventProcess("graphic", responseProcess);
        } catch (socketErr) {
          console.error(socketErr);
        }

        sessionStorage.setItem("reload", 1);
        sendProcess.value = false; // libera antes de navegar (guarda de saída)
        router.push({ name: "home" });
      } catch (err) {
        console.error(err);
        showError(getErrorMessage(err));
      } finally {
        sendProcess.value = false; // sempre cancela a animação
      }
    };

    const backHome = () => {
      router.push("/");
    };

    const searchTerm = ref("");

    const filteredClients = computed(() => {
      const term = searchTerm.value.toLowerCase();
      return clients.value?.filter(
        (client) =>
          client.name.toLowerCase().includes(term) || client.fone.includes(term)
      );
    });

    const getClientName = (clientId) => {
      if (!searchTerm.value && !processPayload.value.client) {
        return "    Pesquisar cliente...";
      }

      const foundClient = clients.value?.find(
        (client) => client.id === clientId
      );

      if (foundClient) {
        searchTerm.value = "";
        return foundClient ? foundClient.name : "";
      }
    };

    const clearSearch = () => {
      searchTerm.value = "";
      processPayload.value.client = null;
    };

    const filterClients = () => {};
    const filterMaterials = () => {};

    const ALLOWED_EXT = ['.jpg', '.jpeg', '.pdf', '.eps'];

    // const LIMIT_BY_TYPE = {
    //   'image/jpeg': 9999999999999999,               // 60 MB
    //   'application/pdf': 9999999999999999,        // 60 MB
    //   'application/postscript': 9999999999999999, // 60 MB (eps)
    // };
    // const DEFAULT_LIMIT_KB = 10240; // fallback, ex: EPS com file.type vazio/genérico

    // const formatLimitLabel = (limitKb) => {
    //   return limitKb >= 1024 ? `${limitKb / 1024}MB` : `${limitKb}KB`;
    // };

    const loadEpsPreview = async (base64Image) => {
      epsPreview.value = null;
      epsPreviewLoading.value = true;

      try {
        const response = await midiaConvertEps({ image: base64Image });
        if (response?.status && response?.image) {
          epsPreview.value = response.image;
        }
      } catch (err) {
        epsPreview.value = null;
      } finally {
        epsPreviewLoading.value = false;
      }
    };

    const fileInput = ref(null);
    const handleFileChange = (event) => {
      processPayload.value.image = null;
      processPayload.value.fileName = null;
      processPayload.value.fileType = null;
      errorLabel.value.image = null;
      epsPreview.value = null;
      epsPreviewLoading.value = false;

      const inputEl = event.target;
      const file = inputEl.files[0];

      if (!file) return;

      const ext = '.' + file.name.split('.').pop().toLowerCase();

      if (!ALLOWED_EXT.includes(ext)) {
        inputEl.value = null;
        errorLabel.value.image = "Formato não suportado. Envie um arquivo JPEG, PDF ou EPS.";
        return;
      }

      // const limitKb = LIMIT_BY_TYPE[file.type] || DEFAULT_LIMIT_KB;
      // const sizeKb = +file["size"] / 1024;

      // if (sizeKb > limitKb) {
      //   inputEl.value = null;
      //   errorLabel.value.image = `Arquivo muito grande, tamanho máximo permitido ${formatLimitLabel(limitKb)}`;
      //   return;
      // }

      const reader = new FileReader();

      reader.onload = () => {
        processPayload.value.image = reader.result;
        processPayload.value.fileName = file.name;
        processPayload.value.fileType = file.type || (ext === '.eps' ? 'application/postscript' : '');

        if (processPayload.value.fileType === 'application/postscript' || ext === '.eps') {
          loadEpsPreview(reader.result);
        }
      };

      reader.onerror = () => {
        inputEl.value = null;
        errorLabel.value.image = "Não foi possível ler o arquivo. Tente novamente.";
      };

      reader.readAsDataURL(file);
    };

    const materialValue = (event) => {
      processPayload.value.material = event;
    }

    onBeforeMount(async () => {
      await store.dispatch("setClientListCurrent");
      await store.dispatch("setMaterialListCurrent");
      getReponseMaterial();
      getReponseClients();
    });

    return {
      materialValue,
      materials,
      fileInput,
      handleFileChange,
      filteredClients,
      filterClients,
      filterMaterials,
      searchTerm,
      clearSearch,
      getClientName,
      registerProcess,
      processPayload,
      backHome,
      clients,
      errorLabel,
      timeError,
      sendProcess,
      isEpsFile,
      epsPreview,
      epsPreviewLoading,
    };
  },
  components:{
    InputSelect
  }

};
</script>

<style scoped>
h1 {
  font-weight: bold;
}
h1,
label,
button {
  font-family: Arial, Helvetica, sans-serif;
}

.custom-mt {
  margin-top: 10px;
  margin-bottom: 80px;
}

h1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.error-label {
  background-color: #be3f3f;
  border-radius: 5px;
  overflow: hidden;
}

.p-error-label {
  font-size: 14px;
  color: red;
}

.search-container {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  color: #888; /* Cor do ícone de pesquisa (pode ser personalizado) */
}

.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  color: #888; /* Cor do ícone (pode ser personalizado) */
}

.custom-link {
  font-size: 15px;
  color: gray;
  font-weight: bold;
  text-decoration: none; /* Remove sublinhado */
  transition: color 0.3s, background-color 0.3s; /* Transição de cor e fundo */
}

.custom-link:hover {
  color: #020202; /* Cor cinza no hover */
  font-weight: bold;
}

/* Adicione um espaçamento entre o label e o link */
.form-label {
  margin-right: 10px;
}

.clickable {
  cursor: pointer;
}

.file-name-preview {
  font-size: 10px;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>